import * as React from 'react';
import { CommandItem } from './types';
import CommandBarSection from './CommandBarSection';

type Section = {
  title: string;
  items: CommandItem[];
  isLoading?: boolean;
};

type Props = {
  id?: string;
  sections: Section[];
  selectedIndex: number;
  onSelect: (item: CommandItem) => void;
};

const CommandBarResults: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  sections,
  selectedIndex,
  onSelect,
}) => {
  if (sections.length === 0) {
    return null;
  }

  let baseIndex = 0;

  return (
    <div id={id} className="command-bar-results" role="listbox">
      {sections.map((section) => {
        const sectionBaseIndex = baseIndex;
        baseIndex += section.items.length;
        return (
          <CommandBarSection
            key={section.title}
            title={section.title}
            items={section.items}
            selectedIndex={selectedIndex}
            baseIndex={sectionBaseIndex}
            isLoading={section.isLoading}
            onSelect={onSelect}
          />
        );
      })}
    </div>
  );
};

export default CommandBarResults;
